interface FilterActionsProps {
  onApply: VoidFunction;
  onReset: VoidFunction;
  close: VoidFunction;
}

export default function FilterActions({ close, onApply, onReset }: FilterActionsProps) {
  return (
    <div className="flex w-full justify-between pt-8">
      <button
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          e.stopPropagation();
          onApply();
          close();
        }}
        className="mt-4 flex w-fit transform rounded-sm bg-emerald-400 px-4 py-2 transition-transform active:scale-95 dark:bg-emerald-600"
      >
        Применить
      </button>
      <button
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          e.stopPropagation();
          onReset();
          close();
        }}
        className="mt-4 flex w-fit transform rounded-sm bg-yellow-400 px-4 py-2 transition-transform active:scale-95 dark:bg-yellow-600"
      >
        Сбросить
      </button>
    </div>
  );
}
